const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.1 40.3",
    style: {
      enableBackground: "new 0 0 46.1 40.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898e96"
    },
    d: "M18.4 12.6c-2.7 0-4.8 2.2-4.8 4.9s2.2 4.8 4.9 4.8 4.8-2.2 4.8-4.9c-.1-2.7-2.3-4.8-4.9-4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898e96"
    },
    d: "M36.7 21.6V9.2c0-2.5-2-4.5-4.5-4.5h-5.7l-1.7-3.5C24.4.5 23.6 0 22.7 0H14c-.9 0-1.6.5-2 1.3l-1.8 3.5H4.5C2 4.8 0 6.8 0 9.3v17.2C0 29 2 31 4.5 31H27.4c0 5.2 4.2 9.4 9.4 9.5s9.4-4.2 9.5-9.4c-.1-5.2-4.3-9.4-9.6-9.5zm-18.3 4c-4.5 0-8.2-3.8-8.1-8.3 0-4.5 3.8-8.2 8.3-8.1 4.5 0 8.1 3.7 8.1 8.2-.1 4.6-3.8 8.2-8.3 8.2zm18.3 12.1c-3.8 0-6.8-3.1-6.7-6.9 0-3.8 3.1-6.8 6.9-6.7 3.7 0 6.7 3.1 6.7 6.8 0 3.8-3.1 6.8-6.9 6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#898e96"
    },
    d: "M40 29.7h-2v-2c-.1-.7-.7-1.2-1.4-1.2-.6.1-1.1.5-1.2 1.2v2h-2c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2h2v2c.1.7.7 1.2 1.4 1.2.6-.1 1.1-.5 1.2-1.2v-2h2c.7 0 1.2-.6 1.3-1.2 0-.7-.6-1.2-1.3-1.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.52c43f1a23168ef5c7d01540cefa29df.svg";
export { ForwardRef as ReactComponent };